module.exports = __webpack_public_path__ + "static/img/logo00.30db80a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logo00.png
// module id = bMhS
// module chunks = 33